import React, { useState, useEffect } from "react";
import { Trash2, Upload, Plus, X, Save } from "lucide-react";
import api from "@/lib/api";
import { fileToResizedDataUrl } from "@/lib/image";

const INPUT = "w-full px-3 py-2 rounded-lg border outline-none focus:ring-2 text-sm";
const BORDER = { borderColor: "#dcfce7" };
const CATEGORIES = ["Belajar", "Kegiatan", "Fasilitas"];

export default function GalleryAdmin() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", category: "Kegiatan", image: "" });
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    const res = await api.get("/gallery");
    setItems(res.data);
  };
  useEffect(() => { load(); }, []);

  const handleImage = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const dataUrl = await fileToResizedDataUrl(file, 1400, 0.82);
    setForm((f) => ({ ...f, image: dataUrl }));
  };

  const save = async (e) => {
    e.preventDefault();
    if (!form.image) { alert("Pilih foto terlebih dahulu"); return; }
    setSaving(true);
    try {
      await api.post("/gallery", form);
      setForm({ title: "", category: "Kegiatan", image: "" });
      setShowForm(false);
      await load();
    } catch (err) {
      alert("Gagal mengunggah foto");
    } finally {
      setSaving(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Hapus foto ini?")) return;
    await api.delete(`/gallery/${id}`);
    await load();
  };

  return (
    <div data-testid="admin-gallery">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-xl font-bold text-gray-900">Galeri Foto ({items.length})</h2>
        {!showForm && (
          <button onClick={() => setShowForm(true)} data-testid="gallery-add-btn"
            className="inline-flex items-center gap-2 text-white px-4 py-2 rounded-lg text-sm font-semibold" style={{ backgroundColor: "#198530" }}>
            <Plus size={16} /> Upload Foto
          </button>
        )}
      </div>

      {showForm && (
        <form onSubmit={save} data-testid="gallery-form" className="bg-white rounded-xl border p-5 mb-6 space-y-4" style={BORDER}>
          <div className="flex items-center justify-between">
            <h3 className="font-bold text-gray-800">Upload Foto Baru</h3>
            <button type="button" onClick={() => setShowForm(false)} className="text-gray-400 hover:text-gray-600"><X size={20} /></button>
          </div>
          <div className="flex items-center gap-4">
            {form.image ? (
              <img src={form.image} alt="preview" className="w-32 h-24 object-cover rounded-lg border" style={BORDER} />
            ) : (
              <div className="w-32 h-24 rounded-lg border flex items-center justify-center text-gray-300" style={BORDER}>Preview</div>
            )}
            <label className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold cursor-pointer" style={{ backgroundColor: "#eef9f0", color: "#198530" }}>
              <Upload size={16} /> Pilih Foto
              <input type="file" accept="image/*" className="hidden" onChange={handleImage} data-testid="gallery-image" />
            </label>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Judul / Caption</label>
              <input className={INPUT} style={BORDER} value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="gallery-title" />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Kategori</label>
              <select className={INPUT} style={BORDER} value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}>
                {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
          </div>
          <button type="submit" disabled={saving} data-testid="gallery-save"
            className="inline-flex items-center gap-2 text-white px-5 py-2.5 rounded-lg text-sm font-bold disabled:opacity-60" style={{ backgroundColor: "#198530" }}>
            <Save size={16} /> {saving ? "Mengunggah..." : "Simpan"}
          </button>
        </form>
      )}

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {items.map((p) => (
          <div key={p.id} data-testid={`gallery-row-${p.id}`} className="relative rounded-xl overflow-hidden group border" style={BORDER}>
            <img src={p.image} alt={p.title} className="w-full h-32 object-cover" />
            <div className="p-2">
              <p className="text-xs font-semibold text-gray-700 truncate">{p.title || "(tanpa judul)"}</p>
              <p className="text-xs" style={{ color: "#198530" }}>{p.category}</p>
            </div>
            <button onClick={() => remove(p.id)} data-testid={`gallery-delete-${p.id}`}
              className="absolute top-2 right-2 p-1.5 rounded-lg bg-red-600 text-white opacity-0 group-hover:opacity-100 transition-opacity">
              <Trash2 size={14} />
            </button>
          </div>
        ))}
        {items.length === 0 && <p className="col-span-full text-center text-gray-400 py-10">Belum ada foto.</p>}
      </div>
    </div>
  );
}
